const PASSWORD_MIN_LENGTH = 6;

const PASSWORD_VALIDATION_MESSAGE = {
	TOO_SHORT: 'passwordTooShort',
	MISMATCH: 'passwordMismatch',
};

export const validateRegistrationPassword = (password) => {
	if (password.length < PASSWORD_MIN_LENGTH) {
		return {
			valid: false,
			messageKey: PASSWORD_VALIDATION_MESSAGE.TOO_SHORT,
		};
	}

	return { valid: true };
};

export const checkRegistrationPassword = (password, passwordRepeat) => {
	if (password !== passwordRepeat) {
		return {
			valid: false,
			messageKey: PASSWORD_VALIDATION_MESSAGE.MISMATCH,
		};
	}

	return validateRegistrationPassword(password);
};
